import { Link } from "react-router-dom";
import type { GuEvent } from "@/mocks/events";

const formatHeat = (value: number) =>
  value >= 10000 ? `${(value / 10000).toFixed(1)}万` : `${value}`;

interface EventCardProps {
  event: GuEvent;
  index?: number;
}

export default function EventCard({ event, index = 0 }: EventCardProps) {
  return (
    <article
      className="gu-rise group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
      style={{ animationDelay: `${(index % 6) * 60}ms` }}
    >
      <Link to={`/event/${event.id}`} className="relative block h-[180px] w-full overflow-hidden">
        <img
          src={event.cover}
          alt={`${event.title} - 网红吃瓜事件配图`}
          title={`${event.title} 网友热议`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-[1.04]"
        />
        <span className="absolute left-3 top-3 rounded-full bg-foreground-950/75 px-3 py-1 text-xs font-semibold text-background-50 backdrop-blur">
          {event.categoryLabel}
        </span>
      </Link>

      <div className="flex flex-1 flex-col p-5">
        <h3 className="font-heading text-base font-bold leading-snug text-foreground-950">
          <Link to={`/event/${event.id}`} className="cursor-pointer transition-colors hover:text-primary-700">
            {event.title}
          </Link>
        </h3>
        <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">
          {event.summary}
        </p>

        <div className="mt-3 flex flex-wrap gap-1.5">
          {event.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] font-medium text-secondary-900"
            >
              {tag}
            </span>
          ))}
        </div>

        <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1 font-semibold text-foreground-700">
            <i className="ri-fire-line text-primary-500" />
            {formatHeat(event.heat)}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-chat-3-line text-secondary-500" />
            {formatHeat(event.commentCount)} 评论
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line" />
            {event.publishedAt}
          </span>
        </div>
      </div>
    </article>
  );
}